import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Observable } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { accountingDashboardViewModel, accountingDepositInvoiceDTO, accountingDepositReceivedDTO, accountingDTO, accountingFinalInvoiceDTO, accountingDepositInvoiceReportViewModel, accountingBillingEntryReportDTO, accountingBillingStateWiseGroup, accountingDashboardSOListModel, accountingSOListDTO, accoutingInvoiceTabReq,soHoldStatusDTO } from '../models/accounting.model';
import { ApiResponse } from '../../shared/common-model/common.model';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  constructor(private httpRequestService: HttpRequestService) { }

  getAccountingDashboardInfo(data:accountingDTO): Observable<accountingDashboardViewModel> {
    return this.httpRequestService.postData<accountingDashboardViewModel>(ApiUrlConstants.accountingDashboardGetInfo,data);
  }
  getAccountingDepositInvoiceReport(obj:accoutingInvoiceTabReq): Observable<accountingDepositInvoiceReportViewModel[]> {
    return this.httpRequestService.postData<accountingDepositInvoiceReportViewModel[]>(ApiUrlConstants.accountingDepositInvoiceReportGet,obj);
  }
  depositReceived(data:accountingDepositReceivedDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.accountingDepositReceived,data);
  }
  depositInvoiceSend(data:accountingDepositInvoiceDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.accountingDepositInvoiceSend,data);
  }
  finalInvoiceSend(data:accountingFinalInvoiceDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.accountingFinalInvoiceSend,data);
  }
  accSendSOToAccounting(id:string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingSoSendToAccounting}${id}`, "");
  }
  getAccountingPayrollBillingReport(data:accountingBillingEntryReportDTO): Observable<accountingBillingStateWiseGroup[]> {
    return this.httpRequestService.postData<accountingBillingStateWiseGroup[]>(ApiUrlConstants.accountingPayrollBillingReportGet, data);
  }
  accMarkAsAccountingReady(id:string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingSoMarkAsAccountingReady}${id}`, "");
  }
  getAccountingDashboardSOList(data:accountingSOListDTO): Observable<accountingDashboardSOListModel[]> {
    return this.httpRequestService.postData<accountingDashboardSOListModel[]>(ApiUrlConstants.accountingDashboardSoListGetInfo,data);
  }
  accountingClearSubcontractorJobCount(id:string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingClearSubcontractorJobCount}${id}`, "");
  }
  SoHoldStatusUpdate(data:soHoldStatusDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.SoHoldStatusUpdate, data);
  }
}
